import { PlaidLinkOrigin } from 'features/plaid/constants/PlaidLinkOrigins';
import {
  PLAID_INTEGRATION_VERSION_V2,
  PLAID_LINK_ERROR,
} from 'shared/analytics/events/externalAccount';
import { useAnalytics } from 'shared/hooks/analytics/useAnalytics';
import useEvent from 'shared/hooks/useEvent/useEvent';
import { PlaidIntent } from 'shared/hooks/usePlaidV2/types';

type PlaidConsentError = {
  errorStep:
    | 'consent_entry_point'
    | 'agreement_load'
    | 'agreement_accept'
    | 'plaid_open';
  errorType: 'system' | 'validation';
  errorCode?: string;
  errorMessage?: string;
};

// Token and link failures are already logged by usePlaidV2; this only covers
// the consent steps that gate it.
const useLogPlaidConsentError = (plaidOrigin: PlaidLinkOrigin | undefined) => {
  const { logEvent } = useAnalytics();

  return useEvent(
    ({ errorStep, errorType, errorCode, errorMessage }: PlaidConsentError) => {
      logEvent(PLAID_LINK_ERROR, {
        intent: PlaidIntent.Link,
        error_type: errorType,
        error_step: errorStep,
        error_code: errorCode,
        error_message: errorMessage,
        entry_point: plaidOrigin?.entryPoint,
        source_name: plaidOrigin?.sourceName,
        plaidIntegrationVersion: PLAID_INTEGRATION_VERSION_V2,
      });
    },
  );
};

export default useLogPlaidConsentError;
